import { Injectable } from '@angular/core';
import { GlobalVariable } from '.././config/service.config';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AccountService {
  url = GlobalVariable.BASE_API_URL;
  token = `Bearer ${JSON.parse(localStorage.getItem('token'))}`;
  headersc = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Accept', 'application/json');
  constructor(private http: HttpClient) { }

  Recuperar(email: string) {
    return this.http.post(`${this.url}Auth/resetemail/?email=${email}`, null, { headers: this.headersc });
  }
  Change(id: any, clave: string) {
    let cambio = {
      "Id": `${id}`,
      "MensajeRetorno": clave
    };
    return this.http.post(`${this.url}Auth/cambioClave`, JSON.stringify(cambio), { headers: this.headersc });
  }
  Validar(id: string) {
    return this.http.post(`${this.url}Auth/validUser/?iduser=${id}`, null, { headers: this.headersc });
  }

}
